import { URL } from "../../api/Api";
import { catchError,GET,POST } from "../axios/Axios";


export const BuyCredits = async (payload) => {
    try{
        const response = await POST(`${URL}/customers/buy-credits/`,payload,{});
        return response.data;
    } catch (error){
        throw catchError(error);
    }
}